// IllustrationContainer.tsx
import React from "react";
import { View, Text, Image, StyleSheet } from "react-native";
import { FlickOColors } from "./styles/color";
import { getResponsiveSize } from "./styles/globalStyles";

const IllustrationContainer: React.FC = () => {
  return (
    <View style={styles.illustrationContainer}>
      <Image
        source={require("../../../assets/idli.png")}
        style={[
          {
            position: "absolute",
            top: 0,
            left: 0,
          },
          styles.img,
        ]}
      />
      <Image
        source={require("../../../assets/momo.png")}
        style={[
          {
            position: "absolute",
            top: 0,
            right: 0,
          },
          styles.img,
        ]}
      />
      <Image
        source={require("../../../assets/pizza.png")}
        style={[
          {
            position: "absolute",
            bottom: 0,
            left: 0,
          },
          styles.pimg,
        ]}
      />
      <Image
        source={require("../../../assets/burger.png")}
        style={[
          {
            position: "absolute",
            bottom: 0,
            right: 0,
          },
          styles.img,
        ]}
      />
      <View
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Text
          style={{
            color: FlickOColors.white,
            fontSize: getResponsiveSize(50),
            fontWeight: "900",
            fontFamily: "Arial",
            letterSpacing: getResponsiveSize(2),
          }}
        >
          FlickO
        </Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  illustrationContainer: {
    height: getResponsiveSize(350),
    backgroundColor: FlickOColors.primary,
    borderBottomLeftRadius: getResponsiveSize(24),
    borderBottomRightRadius: getResponsiveSize(24),
    overflow: "hidden",
  },
  img: {
    width: getResponsiveSize(150),
    height: getResponsiveSize(160),
  },
  pimg: {
    width: getResponsiveSize(200),
    height: getResponsiveSize(130),
  },
});

export default IllustrationContainer;
